<template>
  <v-container fluid>
    <PageHeader title="Users" icon="mdi-account">
      <template #actions>
        <v-btn color="primary" @click="addNew"><v-icon start>mdi-plus</v-icon> New User</v-btn>
      </template>
    </PageHeader>
    <v-card>

      <div class="ml-4 mb-4">
        <v-text-field
          v-model="searchQuery"
          prepend-icon="mdi-magnify"
          :label="searchLabel"
          single-line
          hide-details
          variant="underlined"
          class="mr-4"
        ></v-text-field>
      </div>

      <v-data-table
        :must-sort="true"
        :no-data-text="''"
        :headers="headers"
        :items="users"
        class="ma-1"
        :items-per-page="-1"
        v-model:sort-by="sortBy"
        :search="searchQuery"
        :loading="loading"
        @click:row="(event, { item }) => selectUser(item)"
      >
        <template v-slot:item.icon="{}">
          <v-icon>mdi-account</v-icon>
        </template>

        <template v-slot:item.emailAddress="{ item }">
          <div v-bind:class="{ inactive: !item.isActive }" v-html="highlight(item.emailAddress, searchQuery)"></div>
        </template>

        <template v-slot:item.firstName="{ item }">
          <div v-html="highlight(item.firstName, searchQuery)"></div>
        </template>

        <template v-slot:item.lastName="{ item }">
          <div v-html="highlight(item.lastName, searchQuery)"></div>
        </template>

        <template v-slot:item.isActive="{ item }">
          {{ item.isActive ? "yes" : "no" }}
        </template>

        <template v-slot:bottom></template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import userService from "@/services/userService";
import Auth0Mixin from "../Auth0Mixin";
import filterService from "@/services/filterService.js";
import searchUtilsService from "@/services/searchUtilsService.js";
import localStorageService from "@/services/localStorageService.js";

import PageHeader from "@/components/PageHeader.vue";

export default {
  name: "UserList",
  mixins: [Auth0Mixin],
  components: { PageHeader },
  data() {
    let state = localStorageService.get("usersList");

    return {
      headers: [
        { title: "", key: "icon", width: 40, sortable: false },
        { title: "Email", key: "emailAddress" },
        { title: "First Name", key: "firstName" },
        { title: "Last Name", key: "lastName" },
        { title: "Active", key: "isActive" },
      ],
      sortBy: [{ key: "emailAddress", order: "asc" }],
      users: [],
      loading: true,
      searchQuery: state ? state.query : "",
      highlight: filterService.highlight,
    };
  },

  watch: {
    searchQuery: function() {
      localStorageService.save("usersList", { query: this.searchQuery });
    },
  },

  computed: {
    searchLabel: function() {
      return searchUtilsService.getLabel("Users", this.users);
    },
  },

  methods: {
    // This method will be called after auth0 is done the handshake
    async init() {
      this.users = await userService.getUserList();
      this.loading = false;
    },

    getStatusColor(user) {
      return user.blocked ? "5px solid rgb(var(--v-theme-error))" : "";
    },

    async addNew() {
      this.$router.push(`/admin/user/create`);
    },

    selectUser(user) {
      this.$router.push(`/admin/user/${user.id}`);
    },
  },
};
</script>
<style scoped>
.inactive {
  text-decoration: line-through;
}
</style>
